import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import { useGetOrdersQuery } from "../../slices/ordersApiSlice";
import { dateFormatterIST } from "../../utils/dateHelper";

const OrderListScreen = () => {
  const {data: orders, isLoading, error} = useGetOrdersQuery();
  return (
    <>
      <h1>Orders</h1>
      {isLoading ? <Loader/> : error ? <Message variant="danger">{error}</Message> : (
          <Table striped hover responsive className="table-sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>USER</th>
              <th>DATE</th>
              <th>TOTAL</th>
              <th>PAID</th>
              <th>STATUS</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { orders
              ?.slice()
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((order) => (
              <tr key={order._id}>
                <td>
                  <Link to={`/order/${order._id}`}>
                    {order._id}
                  </Link>
                </td>
                <td>{order.user && order.user.name}</td>
                <td>{dateFormatterIST(order.createdAt)}</td>
                <td>₹{order.totalPrice}</td>
                <td>
                  { 
                    order.isPaid ?
                      `Paid on ${order.paidAt.substring(0,10)}` : (
                      <FaTimes style={{color:'red'}}/>
                  )}
                </td>
                <td>
                  { 
                    order.delivery.isDelivered ? `Delivered on ${order.delivery.deliveredAt.substring(0,10)}` : (
                      (order.sourcing?.isCollected ? "Collected" :
                        (order.sourcing?.sourcingPartner && order.delivery?.deliveryPartner ? "Sourcing & Delivery Assigned" :
                          (order.sourcing?.sourcingPartner ? "Only Sourcing Assigned" :
                            (order.delivery?.deliveryPartner ? "Only Delivery Assigned" :
                            "Created"
                            )
                          )
                        )
                      )
                    )
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  )
}

export default OrderListScreen